<template>
  <div class="attach">
    <v-tooltip
      v-model="show"
      :top="position === 'top'"
      :bottom="position === 'bottom'"
      :left="position === 'left'"
      :right="position === 'right'"
      :max-width="maxWidth"
      :min-width="minWidth"
      z-index="200000"
      :content-class="[arrowClass, contentClass].join(' ')"
      :attach="attach ? '.attach' : false"
      :disabled="disabled"
      :open-delay="openDelay"
    >
      <template #activator="{ on }">
        <slot
          name="activator"
          :on="on"
        />
      </template>
      <slot name="message">
        <p class="text-center leading-tight mb-0 text-12">
          {{ message }}
        </p>
      </slot>
    </v-tooltip>
  </div>
</template>

<script>
import { keyOfFirstTruthyValue } from '@/util/objectFunctions';

export default {
  name: 'ToolTipWrapper',

  props: {
    position: {
      type: String,
      default: 'top',
      validator: (prop) => ['top', 'bottom', 'left', 'right'].includes(prop),
    },
    message: {
      type: String,
      default: '',
    },
    attach: {
      type: Boolean,
      default: false,
    },
    contentClass: {
      type: String,
      default: '',
    },
    maxWidth: {
      type: [String, Number],
      default: 170,
    },
    minWidth: {
      type: Number,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    openDelay: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      show: false,
    };
  },

  computed: {
    arrowClass() {
      return keyOfFirstTruthyValue({
        'arrow-top': this.position === 'bottom',
        'arrow-bottom': this.position === 'top',
        'arrow-left': this.position === 'right',
        'arrow-right': this.position === 'left',
      });
    },
  },
};
</script>
